const LANGUAGE_LABELS = {
  en: 'English',
  es: 'Spanish',
  fr: 'French',
  it: 'Italian',
  de: 'German',
  pt: 'Portuguese',
  nl: 'Dutch',
  pl: 'Polish',
};

const toLanguageLabel = code => {
  const normalized = String(code || '')
    .trim()
    .toLowerCase();
  return LANGUAGE_LABELS[normalized] || normalized.toUpperCase();
};

const STATION_MISSING_RE =
  /^trainingSession\.moodleLanguageMissingForStation:([a-z0-9-]+):(.+)$/i;
const GLOBAL_INCOMPLETE_RE =
  /^trainingSession\.moodleLanguagesIncompleteForGlobal:([a-z0-9,-]+)$/i;

/**
 * Maps station/global LMS language validation errors onto deliveryMethod field.
 * Returns null when message is not a known moodle-language session error.
 */
export const resolveTrainingSessionMoodleLanguageFieldError = (message, t) => {
  const raw = Array.isArray(message) ? message[0] : message;
  if (typeof raw !== 'string' || !raw.trim()) {
    return null;
  }

  const stationMatch = raw.trim().match(STATION_MISSING_RE);
  if (stationMatch) {
    const language = toLanguageLabel(stationMatch[1]);
    const station = stationMatch[2];
    return t('trainingSession.moodleLanguageMissingForStation', {
      language,
      station,
      defaultValue: `No ${language} LMS course version for station ${station}`,
    });
  }

  const globalMatch = raw.trim().match(GLOBAL_INCOMPLETE_RE);
  if (globalMatch) {
    const languages = globalMatch[1]
      .split(',')
      .filter(Boolean)
      .map(toLanguageLabel)
      .join(', ');
    return t('trainingSession.moodleLanguagesIncompleteForGlobal', {
      languages,
      defaultValue: `E-learning is not available for Global sessions until LMS courses exist for all company languages (missing: ${languages})`,
    });
  }

  return null;
};

export default resolveTrainingSessionMoodleLanguageFieldError;
